var hasProp = window.hasProp;
var extend = window.extend;
var extend = function (child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
    child.__super__ = parent.prototype;
    return child;
  },
  hasProp = {}.hasOwnProperty;
window.Works.CoauthorTags = function (superClass) {
  extend(CoauthorTags, superClass);
  function CoauthorTags() {
    return CoauthorTags.__super__.constructor.apply(this, arguments);
  }
  CoauthorTags.prototype.model = Works.CoauthorTag;
  CoauthorTags.prototype.initialize = function (models, options) {
    var ref, ref1;
    if (models == null) {
      models = [];
    }
    if (options == null) {
      options = {};
    }
    this.workId = options.work_id;
    this.source = options.source;
    this.fetch_dummy_owner = options.fetch_dummy_owner;
    this.on('remove', function (_this) {
      return function (model) {
        return model.rejectAsSuggestion();
      };
    }(this));
    this.comparator = function (model) {
      if (model.has('display_order')) {
        return model.get('display_order');
      } else {
        return 2e308;
      }
    };
    if (this.owner = options.includeOwner) {
      models.push(this._dummyOwnerAuthorTag());
      this.on('sync', function (_this) {
        return function () {
          return _this._addDummyOwnerAuthorTag();
        };
      }(this));
    }
    models = _.map(models, function (_this) {
      return function (model) {
        return _this._prepareModel(model);
      };
    }(this));
    if (((ref = this.owner) != null ? ref.id : void 0) !== ((ref1 = Aedu.User.current) != null ? ref1.id : void 0)) {
      this._lockNonEditableTags(models);
      return this.on('sync', function (_this) {
        return function () {
          return _this._lockNonEditableTags();
        };
      }(this));
    }
  };
  CoauthorTags.prototype._prepareModel = function (model) {
    model = CoauthorTags.__super__._prepareModel.apply(this, arguments);
    if (!model) {
      return;
    }
    if (this.source != null && !model.has('source')) {
      model.set('source', this.source);
    }
    if (this.workId != null && !model.has('work_id')) {
      model.set('work_id', this.workId);
    }
    return model;
  };
  CoauthorTags.prototype._addDummyOwnerAuthorTag = function () {
    this.add(this._dummyOwnerAuthorTag(), {
      silent: true
    });
    return this.sort();
  };
  CoauthorTags.prototype._dummyOwnerAuthorTag = function (owner) {
    if (owner == null) {
      owner = this.owner;
    }
    return new Works.CoauthorTag({
      id: owner.id,
      name: owner.display_name,
      email: owner.email,
      display_order: 0,
      locked: true
    });
  };
  CoauthorTags.prototype._lockNonEditableTags = function (models) {
    if (models == null) {
      models = this.models;
    }
    return _.each(models, function (model) {
      if (model.has('tagging_user_id') && model.get('tagging_user_id') !== $current_user.id) {
        return model.set('locked', true);
      }
    });
  };
  CoauthorTags.prototype.url = function () {
    return $r.api_v0_work_co_author_tags_path({
      subdomain_param: 'api',
      work_id: this.workId,
      fetch_dummy_owner: this.fetch_dummy_owner
    });
  };
  CoauthorTags.prototype.parse = function (response, options) {
    return response.co_author_tags;
  };
  CoauthorTags.prototype.saveOrdering = function () {
    return $.ajax({
      type: 'PUT',
      url: $r.set_order_api_v0_work_co_author_tags_path({
        subdomain_param: 'api',
        work_id: this.workId
      }),
      data: {
        ordered_emails: this.invoke('uniqueEmail')
      }
    });
  };
  return CoauthorTags;
}(Backbone.Collection);
window.extend = extend;
window.hasProp = hasProp;